module.exports = __webpack_public_path__ + "img/loading-img.8f168f54.gif";